/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptDayParting } from '../models/V3StackAdaptDayParting';
import { V3StackAdaptHourlyParting } from '../models/V3StackAdaptHourlyParting';
import { V3StackAdaptWeekdayParting } from '../models/V3StackAdaptWeekdayParting';
import { HttpFile } from '../http/http';

/**
* Flight configuration for StackAdapt campaign
*/
export class V3StackAdaptCampaignFlight {
    /**
    * Flight ID
    */
    'id'?: string;
    /**
    * Daily budget for the flight. Deprecated in favor of grossDailyBudget
    */
    'dailyBudget'?: number;
    /**
    * End time for the flight
    */
    'endTime'?: string;
    /**
    * Whether to pace evenly
    */
    'isPaceEvenly'?: boolean;
    /**
    * Whether to catch up
    */
    'catchUp'?: boolean;
    /**
    * Bid type for the flight
    */
    'bidType'?: string;
    /**
    * Bid amount for the flight
    */
    'bidAmount'?: number;
    'dayParting'?: V3StackAdaptDayParting;
    /**
    * Parting time zone
    */
    'partingTimeZone'?: string;
    /**
    * Lifetime budget for the flight. Deprecated in favor of grossLifetimeBudget
    */
    'lifetimeBudget'?: number;
    /**
    * Start time for the flight
    */
    'startTime'?: string;
    /**
    * The type of the first goal for the flight. One of 'CPC', 'CPCL', 'CPCV', 'CPE', or 'CTR'. Not all goals are supported for all campaign types.
    */
    'firstGoalType'?: string;
    /**
    * The value of the first goal for the flight
    */
    'firstGoalValue'?: number;
    /**
    * The type of the second goal for the flight. One of 'COMPLETION_RATE', 'CPA', 'CPC', 'CPE', 'CTR', 'TIME_ON_SITE_AVERAGE', or 'VIEWABILITY'
    */
    'secondGoalType'?: string;
    /**
    * The value of the second goal for the flight
    */
    'secondGoalValue'?: number;
    /**
    * The viewability goal for the flight
    */
    'viewabilityGoal'?: number;
    /**
    * The budget type for the flight. One of 'COST' or 'IMP'
    */
    'budgetType'?: string;
    'hourlyParting'?: V3StackAdaptHourlyParting;
    'weekdayParting'?: V3StackAdaptWeekdayParting;
    /**
    * Gross daily budget for the flight
    */
    'grossDailyBudget'?: number;
    /**
    * Gross lifetime budget for the flight
    */
    'grossLifetimeBudget'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "dailyBudget",
            "baseName": "dailyBudget",
            "type": "number",
            "format": "float"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "isPaceEvenly",
            "baseName": "isPaceEvenly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "catchUp",
            "baseName": "catchUp",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "bidType",
            "baseName": "bidType",
            "type": "string",
            "format": ""
        },
        {
            "name": "bidAmount",
            "baseName": "bidAmount",
            "type": "number",
            "format": "float"
        },
        {
            "name": "dayParting",
            "baseName": "dayParting",
            "type": "V3StackAdaptDayParting",
            "format": ""
        },
        {
            "name": "partingTimeZone",
            "baseName": "partingTimeZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "lifetimeBudget",
            "baseName": "lifetimeBudget",
            "type": "number",
            "format": "float"
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstGoalType",
            "baseName": "firstGoalType",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstGoalValue",
            "baseName": "firstGoalValue",
            "type": "number",
            "format": "float"
        },
        {
            "name": "secondGoalType",
            "baseName": "secondGoalType",
            "type": "string",
            "format": ""
        },
        {
            "name": "secondGoalValue",
            "baseName": "secondGoalValue",
            "type": "number",
            "format": "float"
        },
        {
            "name": "viewabilityGoal",
            "baseName": "viewabilityGoal",
            "type": "number",
            "format": "float"
        },
        {
            "name": "budgetType",
            "baseName": "budgetType",
            "type": "string",
            "format": ""
        },
        {
            "name": "hourlyParting",
            "baseName": "hourlyParting",
            "type": "V3StackAdaptHourlyParting",
            "format": ""
        },
        {
            "name": "weekdayParting",
            "baseName": "weekdayParting",
            "type": "V3StackAdaptWeekdayParting",
            "format": ""
        },
        {
            "name": "grossDailyBudget",
            "baseName": "grossDailyBudget",
            "type": "number",
            "format": "float"
        },
        {
            "name": "grossLifetimeBudget",
            "baseName": "grossLifetimeBudget",
            "type": "number",
            "format": "float"
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCampaignFlight.attributeTypeMap;
    }

    public constructor() {
    }
}

